<template>
  <section>
    <v-img
      src="https://storage.100asa.com/prod/6211/tr:n-full_s_v5/92213317-4344-44ee-9a83-4f680e0d79cd_nfAxsB4D4"
      lazy-src="https://storage.100asa.com/prod/6211/tr:n-full_l_v5/92213317-4344-44ee-9a83-4f680e0d79cd_nfAxsB4D4"
      alt="hero"
      class="hero-image"
      cover
    >
      <div class="fill-height">
        <v-container class="fill-height">
          <v-row>
            <v-col cols="12" sm="8" lg="6" offset-lg="1">
              <h1
                class="white--text text-h2 font-weight-black text-shadow mb-4"
              >
                Grow with 100ASA
              </h1>
              <h2
                class="white--text text-h5 font-weight-bold text-shadow elevation--text-1"
              >
                Learning never exhausts the mind<br />
                <em class="text-body-1">&mdash; Leonardo da Vinci</em>
              </h2>
              <v-btn
                :class="$vuetify.theme.dark ? 'grey--text text--darken-4' : ''"
                x-large
                nuxt
                class="white h-60 ma-0 mt-12"
                @click="$vuetify.goTo('#content')"
              >
                Discover
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <div class="photographer-credit">
          <span class="white--text text-caption">
            Photo by
            <nuxt-link
              to="/photographer/haris"
              class="white--text no-underline font-weight-bold"
            >
              Ahmad Haris
            </nuxt-link>
          </span>
        </div>
      </div>
    </v-img>
  </section>
</template>

<script>
export default {
  name: 'LearningHero'
}
</script>

<style scoped>
.hero-image {
  height: calc(100vh - 64px);
}
.text-shadow {
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.65);
}
.photographer-credit {
  position: absolute;
  bottom: 12px;
  right: 24px;
}
</style>
